<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Task Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`${test_task.name} Task`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['read test process']">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col cols="6">
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr />

                <b-tr>
                  <b-th class="text-nowrap">
                    Name
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.name }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Description
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.description }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Result Type
                  </b-th>
                  <b-td class="w-100">
                    {{ _.startCase(_.toLower(test_task.result_type)) }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Inspecific Scheduling
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.inspecific_scheduling ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Required
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.required ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Group
                  </b-th>
                  <b-td class="w-100">
                    {{ test_task.group ? 'True' : 'False' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>

          <b-col cols="6">
            <h4>Export Map</h4>

            <div class="p-2 bg-light">
              <pre>{{ test_task.export_map || {} }}</pre>
            </div>
          </b-col>
        </b-row>
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list analysis']">
      <template #gated-content>
        <div>
          <h3>Analyses</h3>
        </div>

        <AnalysisTable
          :analyses="test_task.analyses"
          :show_columns="[
            'name',
            'extraction_method',
            'measurement_method'
          ]"
        />
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list instrument']">
      <template #gated-content>
        <div>
          <h3>Instruments</h3>
        </div>

        <InstrumentTable
          :instruments="test_task.instruments"
          :show_columns="[
            'name',
            'abbrev',
            'description',
            'capacity',
            'runtime'
          ]"
        />
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list test task']">
      <template #gated-content>
        <div>
          <h3>
            Quality Controls
            <b-button
              class="float-right"
              variant="success"
              :to="{
                name: 'Add Quality Control',
                params: {
                  sample_type_id: sample_type_id,
                  test_task: test_task
                }
              }"
            >
              <i class="fal fa-plus" />
            </b-button>
          </h3>
        </div>

        <WorkflowQualityControlTable
          :schedulable_task_id="test_task_id"
          schedulable_task_type="TestTask"
          :show_columns="[
            'name',
            'sheet_label',
            'interval',
            'interval_index',
            'actions'
          ]"
          :show_title="false"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import AnalysisTable from '@/components/lab/analysis/AnalysisTable'
import InstrumentTable from '@/components/lab/instrument/InstrumentTable'
import WorkflowQualityControlTable from '@/components/lab/workflows/WorkflowQualityControlTable.vue'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'

export default {
  name: 'WorkflowTestTaskDetail',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    AnalysisTable,
    InstrumentTable,
    WorkflowQualityControlTable
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      test_process_id: this.$route.params.test_process_id || null,
      test_task_id: this.$route.params.test_task_id || null,
      test_task: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-search",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}/${this.test_task_id}/audit-trail`,
            title: "Audit Trail",
            variant: "dark",
          },
          {
            icon: 'fa-pencil',
            title: 'Edit sample',
            variant: 'warning',
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}/${this.test_task_id}/edit`
          }
        ]
      }
    },
    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async mounted () {
    this.loading = true

    this.test_task = await getModel({
      model_type: 'test_task',
      id: this.test_task_id,
      message: this.$bvToast
    })

    this.test_task ? (this.loading = false) : this.$router.back()
  }
}
</script>
